<template>
  <div style="display: flex; justify-content: flex-end; margin-bottom: -32px; z-index: 9999">

    <el-button size="small" style="z-index: 9999" @click="importObject = true">Импортировать</el-button>

    <el-dialog
      append-to-body
      title="Импорт из планов"
      :visible.sync="importObject"
    >
      <div v-if="selectedPlan">
        <div class="add-jobs" v-show="!objectId">
          <el-input placeholder="Поиск ..." v-model="search" class="input-search">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
          <el-table
            @select="handleSelectionChangeObject"
            @select-all="handleSelectionChangeObject"
            row-key="id"
            empty-text="Объекты не найдены"
            ref="multipleObjectTable"
            :data="filteredList"
            style="width: 100%"
          >
            <el-table-column
              property="check"
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column
              property="name"
              label="Объекты"
            >
            </el-table-column>
            <el-table-column
              width="50px"
            >
              <template slot-scope="scope">
                <i class="fa fa-edit" @click="selectObject(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="add-jobs" v-show="objectId" v-loading="loading">
          <el-input placeholder="Поиск ..." v-model="jobSearch" class="input-search">
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
          <div class="jobs-ul">

            <el-table
              @selection-change="handleSelectionChangeJob"
              empty-text="Работы не найдены"
              ref="jobsTable"
              :data="filteredJobs"
              style="width: 100%"
            >
              <el-table-column
                property="check"
                type="selection"
                width="55"
              ></el-table-column>
              <el-table-column
                property="name"
                label="Работы"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="create-footer">
          <el-button @click="back">Назад</el-button>
          <el-button type="primary" @click="save">Импортировать</el-button>
        </div>
      </div>
      <div class="jobs-ul" v-else>
        <div
          class="jobs-li" @click="selectPlan(plan)" v-for="(plan, index) in filteredPlan" :key="index"
        >
          <div class="name">
            <span style="margin-left: 10px">{{ plan.name || plan.label }}</span>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getPlans} from "../../../../firestore/plan";
import ImportJobsContent from "../../Jobs/components/ImportJobsContent";
import firebase from 'firebase'
import _ from "lodash";
import {getChildList} from "../../../../utils/getChild";

export default {
  name: "ImportObject",
  components: {ImportJobsContent},
  data() {
    return {
      importObject: false,
      plans: [],
      searchPlan: '',
      selectedPlan: null,
      search: '',
      jobSearch: '',
      dialogObject: false,
      objectId: null,
      selectedObjects: [],
      selectedJob: [],
      loading: false,
      availableJobs: {},
      availableObjects: [],
      usePermission: false,
      list: [],
      jobs: [],
    }
  },
  mounted() {
    this.fetchPlans();
  },
  watch: {
    filteredList: _.debounce(function () {
      this.filteredList.map((row) => {
        const availableObjects = this.availableObjects.map((a) => a.id);
        if (availableObjects.includes(row.id)) {
          this.$refs.multipleObjectTable.toggleRowSelection(row);
        }
      })
    }, 200),
    filteredJobs: _.debounce(function () {
      this.filteredJobs.map((row) => {

        if(!this.availableJobs[this.objectId]) {
          this.availableJobs[this.objectId] = []
        }

        const availableJobs1 = this.availableJobs[this.objectId].map((a) => a.id);


        if (availableJobs1.includes(row.id)
        ) {
          this.$refs.jobsTable.toggleRowSelection(row);
        }
      })
    }, 200)
  },
  methods: {
    save() {},
    selectPlan(plan) {
      this.selectedPlan = plan
      this.fetchTree();
    },
    async fetchPlans() {
      this.loader = true;

      try {
        this.plans = await getPlans(this.$store.state.project.id);
      } catch (e) {
        console.log(e, 'e');
      }

      this.loader = false;
    },



    fire() {
      if(this.selectedPlan && this.selectedPlan.id) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.selectedPlan.id)
      }
      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    selectObject({id}) {
      this.objectId = id;
      this.fetchJobs();
    },
    back() {
      if(!this.objectId) {
        return this.selectedPlan = null
      }
      this.objectId = null;
    },
    fetchJobs() {

      this.fire()
        .collection('jobs')
        .where('type', '==', 'JOB')
        .where(`objects`, 'array-contains-any', [this.objectId]).get()
        .then((data) => {
          const result = [];
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              _data: data,
              index: data.index
            });
          });

          this.jobs = _.orderBy(result, 'index', ['asc']);
        });
    },
    handleSelectionChangeObject(selected) {
      this.selectedObjects = selected;
      this.availableObjects = this.list.filter((s) => {
        return this.selectedObjects.find((l) => l.id === s.id)
      });
    },
    handleSelectionChangeJob(selected) {
      this.selectedJob = selected;
      this.availableJobs[this.objectId] = [...selected, ...this.availableJobs[this.objectId]];
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      this.fire()
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              id: subDoc.id,
              name: data.name,
              objects: data.objects,
              index: data.index,
              parentId: data.parentId || undefined,
              isParent: data.isParent,
            });
          });
        }).finally(() => {
        if(!this.planId) {
          this.list = [
            {
              id: 'all',
              name: 'Корневой каталог',
              index: 0,
              isParent: true,
            },
            ..._.orderBy(getChildList(result), 'index', ['asc']),
          ];
        } else {
          this.list = [
            ..._.orderBy(getChildList(result), 'index', ['asc']),
          ];
        }
        this.loader = false;
      }).catch(() => {
        this.loader = false;
      });
    },
  },
  computed: {
    filteredPlan() {
      return this.plans.filter(plan => {
        try {
          if (!plan.name) return false
          return String(plan.name).toLowerCase().includes(this.searchPlan.toLowerCase());
        } catch (e) {
          return false
        }
      });
    },
    filteredList() {
      return this.list.filter(object => {
        return object.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
    filteredJobs() {
      return this.jobs.filter(object => {
        return object.name.toLowerCase().includes(this.jobSearch.toLowerCase());
      });
    },
  },
}
</script>

<style scoped lang="scss">
.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    cursor: pointer;
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 8px 12px;
    text-align: left;

    &:hover {
      background: #f0f0f0;
    }

  }
}


.back {
  cursor: pointer;
  margin-bottom: 16px;
  color: #000;

  span {
    margin-left: 4px;
  }
}
.create-footer {
  margin-top: 22px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Objects/components/ImportObject.vue